import { Flex } from '@chakra-ui/react';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';

import { isNetchexLogin } from 'constants/netChexConstants';

import { CompetencyAccess } from './CompetencyAccess';
import { CompetencyLevels } from './CompetencyLevels';
import { CompetencySettingsFooter } from './CompetencySettingsFooter';

export const CompetencySettings = ({
  setShowSettingsScreen,
}: {
  setShowSettingsScreen?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { hasFeedbackAccess, hasIDPAccess } = getUserL2Access();

  return (
    <Flex
      padding="12px"
      flexDir="column"
      gap="16px"
      height="calc(100vh - 125px)"
      overflow="scroll"
      mb={isNetchexLogin ? 8 : 0}
    >
      <CompetencyAccess />
      {hasFeedbackAccess && hasIDPAccess && <CompetencyLevels />}
      <CompetencySettingsFooter setShowSettingsScreen={setShowSettingsScreen} />
    </Flex>
  );
};
